import React from "react";
import { Skeleton } from "../skeleton";

/**
 * Loading placeholder for the admin HomePage — shaped like the real page: greeting
 * header, two rows of stat cards, then the seat usage card.
 */
export const HomePageSkeleton: React.FC = () => {
    return (
        <div className="p-6">
            {/* Date + greeting */}
            <div className="mb-4 flex flex-col gap-2">
                <Skeleton className="h-3 w-40" />
                <Skeleton className="h-7 w-64" />
            </div>

            {/* Stat card row 1 */}
            <div className="border-border bg-card divide-border flex flex-col divide-y rounded-2xl border sm:flex-row sm:divide-x sm:divide-y-0">
                {Array.from({ length: 3 }).map((_, i) => (
                    <div key={i} className="min-w-0 flex-1 p-5">
                        <Skeleton className="mb-2 h-3 w-20" />
                        <Skeleton className="h-6 w-16" />
                    </div>
                ))}
            </div>

            {/* Stat card row 2 */}
            <div className="border-border bg-card divide-border mt-4 flex flex-col divide-y rounded-2xl border sm:flex-row sm:divide-x sm:divide-y-0">
                {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} className="min-w-0 flex-1 p-5">
                        <Skeleton className="mb-2 h-3 w-24" />
                        <Skeleton className="mb-2 h-6 w-16" />
                        {i < 3 && <Skeleton className="h-3 w-32" />}
                    </div>
                ))}
            </div>

            {/* Seat usage */}
            <div className="border-border bg-card mt-4 flex flex-col rounded-2xl border">
                <div className="flex items-start justify-between px-5 pt-5 pb-4">
                    <div>
                        <Skeleton className="mb-2 h-4 w-24" />
                        <Skeleton className="h-3 w-32" />
                    </div>
                    <Skeleton className="h-4 w-32" />
                </div>
                <div className="divide-border flex flex-col divide-y">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="flex items-center gap-3 px-5 py-4">
                            <Skeleton className="h-9 w-9 shrink-0 rounded-full" />
                            <div className="min-w-0 flex-1">
                                <Skeleton className="mb-1 h-4 w-32" />
                                <Skeleton className="h-3 w-20" />
                            </div>
                            <Skeleton className="h-8 w-48 shrink-0 rounded-md sm:w-56" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
